import { render, staticRenderFns } from "./StudentWritingSubmission.vue?vue&type=template&id=6df07d94"
import script from "./StudentWritingSubmission.vue?vue&type=script&lang=js"
export * from "./StudentWritingSubmission.vue?vue&type=script&lang=js"
import style0 from "./StudentWritingSubmission.vue?vue&type=style&index=0&id=6df07d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports